import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CardService } from './card/card.service';

@Injectable()

export class AppResolve implements Resolve<{}> {
    constructor(private service: CardService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.service.userResolver();
    }
}
